import styled from "styled-components";

const PatientListWrapper = styled.div`
  flex: auto;
  justifycontent: center;
  display: flex;
  overflow: auto;
  .patientsContainer {
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    h4 {
      padding-top: 10px;
    }
    .ant-checkbox + span {
      font-size: 18px;
    }
  }
`;

export default PatientListWrapper;
